const MAX_WIDTH_PETIT_ORDI = 1200;
const MAX_WIDTH_TABLETTE = 1024;
const MAX_WIDTH_GRAND_SMARTPHONE = 768;
const MAX_WIDTH_PETIT_SMARTPHONE = 480;

module.exports = {
  MAX_WIDTH_PETIT_ORDI,
  MAX_WIDTH_TABLETTE,
  MAX_WIDTH_GRAND_SMARTPHONE,
  MAX_WIDTH_PETIT_SMARTPHONE,
};
